import { getTeeColor } from '@/lib/utils';
import React from 'react';

interface TeeBadgeProps {
  teeName?: string;
  defaultTee?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
}

const TeeBadge: React.FC<TeeBadgeProps> = ({
  teeName,
  defaultTee = 'W',
  size = 'md',
  className = '',
}) => {
  // Determine the display letter
  const displayLetter = teeName 
    ? teeName.charAt(0).toUpperCase() 
    : defaultTee.charAt(0).toUpperCase();

  // Get the color based on tee name
  const teeColor = getTeeColor(teeName || defaultTee);

  // Size classes
  const sizeClasses = {
    xs: 'size-4 text-[10px]',
    sm: 'size-6 text-xs',
    md: 'size-8 text-sm',
    lg: 'size-10 text-base',
  };

  return (
    <div
      className={`rounded-full flex items-center justify-center font-bold mix-blend-difference ${sizeClasses[size]} ${teeColor} ${className}`}
    >
      {displayLetter}
    </div>
  );
};

export default TeeBadge;
